export const buildStepItems = (steps: { title: string; description: string }[], current: number) =>
    steps.map((step, idx) => ({
        title: step.title,
        description: step.description,
        status: current === idx ? "process" as const : "wait" as const,
    }));
